<!--TODO - Replace PIPE-->
<div class="date-container">
  <div class="programed-row">
  </div>
  <div class="date-row text-subtitle-bold-upper opacity-60" *ngIf="!hideIndicatorMonth">
    {{ this.selectedDate | formatDate:"dd MMM yyyy":es }}
  </div>
  <h2 class="day-selected text-title-lgx-bold text-capitalize d-flex align-items-center justify-content-between" *ngIf="!hideIndicatorToday">
    <span *ngIf="this.selectedDate | isToday; else isnttoday">
      Hoy
    </span>
    <ng-template #isnttoday> {{ this.selectedDate | formatDate:"iii":es }} </ng-template>
    <button id="btn-add-appointment" class="btn-add-appointment" nz-button nzType="primary" *ngIf="showAddAppointment" (click)="onEmitAddAppointment()">
      <i nz-icon nzType="schedule" nzTheme="outline"></i> Agendar cita
    </button>
  </h2>
  <div class="week-row">
    <i (click)="onPrevWeek()" nz-icon nzType="caret-left" nzTheme="outline" class="icon-arrow-date text-info-bold"></i>
    <div
      *ngFor="let day of this.showingWeek; let index= index"
      class="week-day"
      [ngClass]="{
      today: day | isToday,
      selected: day | compareDates:this.selectedDate:'===',
      disabled: (day | getDifferentInCalendarDays) && disabledPastDays
      }"
      (click)="onSelectedDay(day)">
      <div class="text-info text-capitalize">{{ day | formatDate:"iii":es }}</div>
      <div class="text-info-bold">{{ day | getDate }}</div>
    </div>
    <i (click)="onNextWeek()" nz-icon nzType="caret-right" nzTheme="outline" class="icon-arrow-date text-info-bold"></i>
  </div>
</div>
